import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import '../index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';

import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';
const reqDlvyDateToDate = params => formatGivenDate( params.data.reqDlvyDate, 'DD-MMM-YY' );
const dateTimeUpdatedToDate = params => formatGivenDate( params.data.dateTimeUpdated, 'YYYY-MM-DD HH:mm:ss' );
const materialAvlDateToDate = params => formatGivenDate( params.data.materialAvlDate, 'DD-MMM-YY' );
const productAvlDateToDate = params => formatGivenDate( params.data.productAvlDate, 'DD-MMM-YY' );

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}



const colDefs = [
    {
        field: 'inventorySource',
        headerName: 'Factory',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 120
    },
	{
        field: 'orgOrderNumber',
        headerName: 'Original Order Number',
        sortable: true,
        filter: true,
        width: 120
    },
    {
        field: 'dateTimeUpdated',
        headerName: 'Update Timestamp',
        sortable: true,
        filter: true,
        width: 100,
        valueGetter: dateTimeUpdatedToDate
    },
    {
        field: 'typeOfActivity',
        headerName: 'Type of Activity',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'dlrResponseCode',
        headerName: 'Dealer Response Code',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'factResponseCode',
        headerName: 'Factory Response Code',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'reqDlvyDate',
        headerName: 'Req Dlvy Date',
        sortable: true,
        filter: true,
        width: 100,
        valueGetter: reqDlvyDateToDate
    },
    {
        field: 'materialAvlDate',
        headerName: 'Initial MAD',
        sortable: true,
        filter: true,
        width: 100,
        valueGetter: materialAvlDateToDate
    },
    {
        field: 'productAvlDate',
        headerName: 'Final MAD',
        sortable: true,
        filter: true,
        width: 100,
        valueGetter: productAvlDateToDate
    },
    {
        field: 'baseMachineCode',
        headerName: 'Base Code',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'racfId',
        headerName: 'RacfId',
        sortable: true,
        filter: true,
        width: 105
    },
    {
        field: 'errorCode',
        headerName: 'Error Code',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'errorMessage',
        headerName: 'Error Message',
        sortable: true,
        filter: true
    }
];

const AuditLogTable = props => (

    <section className="atp-search-result-panel auditlog-result-panel atp-ag-grid ag-theme-balham ag-theme-popupbg">

        <AgGridReactComponent
            reactNext={true}
            columnDefs={colDefs}
            rowData={props.results}
            onGridReady={onGridReady}
        />

    </section>
);

AuditLogTable.propTypes = {
    results: PropTypes.array.isRequired
};
export default AuditLogTable;
